import React from 'react';
import { Link } from 'react-router-dom';
import gmaxLogo from '../assets/optimized/gmax-logo-transparent-new.png';

const ServiceCard = ({ title, description, icon }) => {
  return (
    <div className="card hover:border-gmax-blue hover:border-l-4 transition-all">
      <div className="text-gmax-blue mb-4 text-4xl">
        {icon}
      </div>
      <h3 className="text-xl font-bold mb-2 text-gmax-dark-blue">{title}</h3>
      <p className="text-gray-600 mb-4">{description}</p>
      <Link to="/servicos" className="text-gmax-blue font-medium hover:underline">
        Saiba mais →
      </Link>
    </div>
  );
};

const Home = () => {
  return (
    <div>
      {/* Hero Section */}
      <section className="bg-gmax-dark-blue text-white py-8">
        <div className="container mx-auto px-4">
          <div className="flex flex-col md:flex-row items-center">
            <div className="md:w-1/2 mb-8 md:mb-0">
              <h1 className="text-4xl md:text-5xl font-bold mb-4">
                Soluções completas em <span className="text-gmax-blue">facilities</span>
              </h1>
              <p className="text-xl mb-8">
                Oferecemos serviços terceirizados de alta qualidade para sua empresa, com atendimento imediato e preço competitivo.
              </p>
              <div className="flex flex-col sm:flex-row gap-4">
                <Link to="/servicos" className="btn-primary text-center">
                  Nossos Serviços
                </Link>
                <Link to="/contato" className="bg-transparent border-2 border-white text-white font-semibold py-2 px-6 rounded-md hover:bg-white hover:text-gmax-dark-blue transition-all duration-300 text-center">
                  Fale Conosco
                </Link>
              </div>
            </div>
            <div className="md:w-1/2 flex justify-center">
              <img 
                src={gmaxLogo} 
                alt="GMAX Soluções em Facilities" 
                className="max-w-full h-auto rounded-lg shadow-lg"
                style={{ maxHeight: '250px' }}
              />
            </div>
          </div>
        </div>
      </section>

      {/* Services Section */}
      <section className="py-16 bg-gray-50">
        <div className="container mx-auto px-4">
          <div className="text-center mb-12">
            <h2 className="section-title">Nossos Serviços</h2>
            <p className="text-gray-600 max-w-3xl mx-auto">
              Oferecemos uma ampla gama de serviços de facilities para atender às necessidades da sua empresa.
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
            <ServiceCard 
              title="Limpeza Profissional" 
              description="Serviços de limpeza e conservação para ambientes corporativos, com equipe treinada e produtos de qualidade."
              icon={<i className="fas fa-broom"></i>}
            />
            <ServiceCard 
              title="Manutenção Predial" 
              description="Manutenção preventiva e corretiva para garantir o funcionamento adequado das instalações da sua empresa."
              icon={<i className="fas fa-tools"></i>}
            />
            <ServiceCard 
              title="Segurança Patrimonial" 
              description="Proteção do patrimônio físico e humano da sua empresa, com profissionais qualificados e tecnologia avançada."
              icon={<i className="fas fa-shield-alt"></i>}
            />
          </div>

          <div className="text-center mt-12">
            <Link to="/servicos" className="btn-primary">
              Ver Todos os Serviços
            </Link>
          </div>
        </div>
      </section>

      {/* Differentials Section */}
      <section className="py-16">
        <div className="container mx-auto px-4">
          <div className="text-center mb-12">
            <h2 className="section-title">Nossos Diferenciais</h2>
            <p className="text-gray-600 max-w-3xl mx-auto">
              O que nos torna a escolha ideal para sua empresa.
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
            <div className="text-center p-6 bg-white rounded-lg shadow-md hover:shadow-lg transition-all">
              <div className="text-gmax-blue text-4xl mb-4">
                <i className="fas fa-database"></i>
              </div>
              <h3 className="text-xl font-bold mb-2 text-gmax-dark-blue">Banco de Dados Nacional</h3>
              <p className="text-gray-600">
                Contamos com um amplo banco de dados de profissionais em várias cidades, permitindo contratações imediatas.
              </p>
            </div>
            
            <div className="text-center p-6 bg-white rounded-lg shadow-md hover:shadow-lg transition-all">
              <div className="text-gmax-blue text-4xl mb-4">
                <i className="fas fa-dollar-sign"></i>
              </div>
              <h3 className="text-xl font-bold mb-2 text-gmax-dark-blue">Preço Competitivo</h3>
              <p className="text-gray-600">
                Oferecemos serviços de alta qualidade com preços competitivos, garantindo o melhor custo-benefício.
              </p>
            </div>
            
            <div className="text-center p-6 bg-white rounded-lg shadow-md hover:shadow-lg transition-all">
              <div className="text-gmax-blue text-4xl mb-4">
                <i className="fas fa-bolt"></i>
              </div>
              <h3 className="text-xl font-bold mb-2 text-gmax-dark-blue">Atendimento Imediato</h3>
              <p className="text-gray-600">
                Respondemos rapidamente às suas necessidades, com capacidade de mobilização imediata de equipes.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="py-16 bg-gmax-blue text-white">
        <div className="container mx-auto px-4 text-center">
          <h2 className="text-3xl md:text-4xl font-bold mb-6">Pronto para otimizar a gestão de facilities da sua empresa?</h2>
          <p className="text-xl mb-8 max-w-3xl mx-auto">
            Entre em contato conosco hoje mesmo e descubra como podemos ajudar sua empresa a focar no que realmente importa.
          </p>
          <Link to="/contato" className="bg-white text-gmax-blue font-semibold py-3 px-8 rounded-md hover:bg-opacity-90 transition-all duration-300 inline-block">
            Solicite um Orçamento
          </Link>
        </div>
      </section>
    </div>
  );
};

export default Home;
